import { makeAutoObservable } from 'mobx';
import AccountingService from '../services/accounting-service';

const createItemList = (items) => {
    const unique = {};
    const result = [];
    for (const item of items) {
        if (unique[item.type_id]) continue;
        unique[item.type_id] = true;
        result.push({
            type_id: item.type_id,
            type: item.type,
        });
    }
    return result;
};

class KosaAccountingStore {
    loading = false;
    items = [];
    deviceTypes = [];

    filter = {};
    sort = {};

    constructor() {
        makeAutoObservable(this);
    }

    async load() {
        this.loading = true;
        try {
            const response = await AccountingService.accounting(this.filter, this.sort);
            this.items = response.data;
            if (this.deviceTypes.length === 0) this.deviceTypes = createItemList(response.data); // Только при первом запросе
        } catch (e) {
            throw e;
        } finally {
            this.loading = false;
        }
    }

    async setFilter(filter) {
        this.filter = filter;
        await this.load();
    }

    async setSort(sort) {
        this.sort = sort;
        await this.load();
    }

    async update(item, quantity, note) {
        await AccountingService.correction(item.component_id, quantity, note);
        await this.load();
    }

    async setMinQuantity(item, quantity) {
        await AccountingService.setMin(item.component_id, quantity);
        await this.load();
    }
}

export default KosaAccountingStore;
